import { makeAutoObservable } from 'mobx'
import { type ModalFullScreenType } from './types'

class ModalFullScreenStore {
  modalsMap = new Map<string, ModalFullScreenType>()

  constructor() {
    makeAutoObservable(this)
  }

  get modals() {
    return Array.from(this.modalsMap.values())
  }

  getModal = (id: string) => {
    return this.modalsMap.get(id)
  }

  addModal = <T extends object = object>(modal: ModalFullScreenType<T>) => {
    this.modalsMap.set(modal.id, modal as ModalFullScreenType<object>)
  }

  removeModal = (id: string) => {
    this.modalsMap.delete(id)
  }

  closeModal = (id: string) => {
    const modal = this.modalsMap.get(id)
    if (modal && 'onClose' in modal && modal.onClose) {
      modal?.onClose()
    } else {
      this.removeModal(id)
    }
  }

  closeAllModals = () => {
    this.modalsMap.forEach((modal) => {
      this.closeModal(modal.id)
    })
  }
}

export default new ModalFullScreenStore()
